// @ts-nocheck




import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { serviceTypes } from '../../lib/enum/serviceTypes';
import { Option, Select } from './../ant/Select';
import {
  getLabeledSelectValue,
  toLabeledSelectValue,
} from './labelInValue';

export default ({ value, onChange, ...selectProps }) => {
  const { filter } = selectProps;
  const filtered =
  !isEmpty(filter) && isArray(filter.having) ?
  Object.keys(serviceTypes).filter((service) =>
  filter.having.includes(service)
  ) :
  Object.keys(serviceTypes);
  let val;
  if (isArray(value)) {
    val = (value || []).map((key) =>
      toLabeledSelectValue(key, serviceTypes[key])
    );
  } else {
    val = value ?
    toLabeledSelectValue(value, serviceTypes[value]) :
    undefined;
  }
  return (
    <Select
      placeholder="Выберите виды услуг"
      {...selectProps}
      labelInValue
      allowClear
      value={val}
      onChange={(selected) => {
        if (isArray(selected)) {
          onChange(
            selected.map(getLabeledSelectValue)
          );
        } else {
          onChange(selected ? getLabeledSelectValue(selected) : undefined);
        }
      }}>

      {filtered.map((key) =>
      <Option key={key} value={key}>
          {serviceTypes[key]}
        </Option>
      )}
    </Select>);

};
